/**
 * vacancyTransform — vacancy row label/type resolution from Angular
 * `DEEComponent.getAllVacancies()` / `getSelectedVacancies()`.
 */

import { Option } from './types';
import { designationLabel } from './transform';
import { TYPE_LIST } from '../../../shared/services/defaultValues';

/* eslint-disable @typescript-eslint/no-explicit-any */

const str = (v: any): string =>
  v === null || v === undefined ? '' : String(v);

/** Resolve a school gender-type code to its label using the shared TYPE_LIST. */
const typeLabel = (t: any): string => {
  const found = TYPE_LIST.find((opt) => opt.value === str(t));
  return found ? found.label : '-';
};

const subjectLabel = (subList: Option[], value: any): string => {
  const found = subList.filter((ct) => str(ct.value) === str(value));
  return found.length > 0 ? found[0].label : '';
};

/** Decorate a vacancy list with subjectLabel / type / minority / DesignationLabel. */
export function decorateVacancies(
  result: any[],
  subList: Option[],
  designationList: any[]
): any[] {
  return (result ?? []).map((row) => ({
    ...row,
    subjectLabel: subjectLabel(subList, row.Subject),
    type: typeLabel(row.type),
    minority: row.Minority_Type ? row.Minority_Type : '-',
    DesignationLabel: designationLabel(designationList, row.Designation),
  }));
}

/** Decorate selected-vacancy list (no minority field in Angular). */
export function decorateSelectedVacancies(
  result: any[],
  subList: Option[],
  designationList: any[]
): any[] {
  return (result ?? []).map((row) => ({
    ...row,
    subjectLabel: subjectLabel(subList, row.Subject),
    type: typeLabel(row.type),
    DesignationLabel: designationLabel(designationList, row.Designation),
  }));
}

/* eslint-enable @typescript-eslint/no-explicit-any */
